let returnFocus: HTMLElement | null = null;
const initializedRoots = new WeakSet<Document>();
const initializedDialogs = new WeakSet<HTMLDialogElement>();

export function initializeSettingsDialogs(root: Document = document) {
  const dialogs = [...root.querySelectorAll<HTMLDialogElement>("dialog[data-settings-dialog]")];
  for (const dialog of dialogs) prepareDialog(dialog, root);

  if (initializedRoots.has(root)) return;
  initializedRoots.add(root);

  root.addEventListener("click", event => {
    const target = event.target as Element | null;
    const opener = target?.closest<HTMLElement>("[data-open-settings-dialog]");
    if (opener) {
      const id = opener.dataset.openSettingsDialog;
      const dialog = id ? root.getElementById(id) : null;
      if (dialog instanceof HTMLDialogElement) {
        event.preventDefault();
        openSettingsDialog(dialog, opener, root);
      }
      return;
    }

    const dialog = target?.closest<HTMLDialogElement>("dialog[data-settings-dialog]");
    if (!dialog) return;
    if (target === dialog || target?.closest("[data-close-settings-dialog]")) {
      dialog.close();
    }
  });

  root.addEventListener("qprins:open-dialog", event => {
    const id = (event as CustomEvent<{ id?: string }>).detail?.id;
    const dialog = id ? root.getElementById(id) : null;
    if (!(dialog instanceof HTMLDialogElement)) return;

    const opener = returnFocus;
    root.querySelectorAll<HTMLDialogElement>("dialog[data-settings-dialog][open]")
      .forEach(openDialog => {
        if (openDialog !== dialog) openDialog.close();
      });
    openSettingsDialog(dialog, opener, root);
  });

  const automatic = dialogs.find(dialog => dialog.dataset.openOnLoad === "true");
  if (automatic) openSettingsDialog(automatic, null, root);
}

function prepareDialog(dialog: HTMLDialogElement, root: Document) {
  if (initializedDialogs.has(dialog)) return;
  initializedDialogs.add(dialog);
  dialog.addEventListener("close", () => {
    updatePageLock(root);
    if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
    returnFocus = null;
  });
}

function openSettingsDialog(
  dialog: HTMLDialogElement,
  opener: HTMLElement | null,
  root: Document) {
  if (dialog.open) return;
  prepareDialog(dialog, root);
  returnFocus = opener;
  dialog.showModal();
  updatePageLock(root);
  window.requestAnimationFrame(() => {
    dialog.querySelector<HTMLElement>("[autofocus], input, button")?.focus({ preventScroll: true });
  });
}

function updatePageLock(root: Document) {
  if (root.querySelector("dialog[data-settings-dialog][open]")) {
    root.documentElement.dataset.settingsDialogOpen = "true";
  } else {
    delete root.documentElement.dataset.settingsDialogOpen;
  }
}
